<script lang="ts">
  import Spinner from './Spinner.svelte'

  export let placeholder: string
  export let loading = false
</script>

<div class="empty-section tc">
  {#if loading}
    <Spinner/>
  {:else}
    {placeholder}
  {/if}
</div>
